"use client";

import React from "react";
import { ShieldCheck, Boxes, ShoppingCart, Settings, Cloud, ChartBar, FileText, Network } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const modules = [{
  title: "Comprehensive Compliance",
  description: "Ensuring compliance requires continuous monitoring across all departments. Implement robust tracking to prevent discrepancies and maintain accuracy.",
  icon: ShieldCheck
}, {
  title: "Advanced Resource Management",
  description: "Automated solutions ensure regulatory adherence, minimize errors, and streamline resource allocation and reporting for greater efficiency.",
  icon: Boxes
}, {
  title: "Centralized Procurement",
  description: "Enhance procurement by optimizing supplier oversight, refining costs, and ensuring seamless management for improved public sector efficiency.",
  icon: ShoppingCart
}, {
  title: "Complete Operations Module",
  description: "Enable comprehensive management of entire operational processes, encompassing planning, execution, and compliance documentation.",
  icon: Settings
}, {
  title: "Mobile & Cloud Accessibility",
  description: "Secure, anywhere-access to critical government systems, ensuring continuity of operations and real-time decision making in the field.",
  icon: Cloud
}, {
  title: "Data-Driven Analytics",
  description: "Provide agencies with comprehensive dashboards and reports, facilitating the optimization of public services and resource distribution.",
  icon: ChartBar
}, {
  title: "Regulatory Reporting",
  description: "Automated compliance solutions ensure adherence to local and federal regulations, significantly reducing manual reporting errors.",
  icon: FileText
}, {
  title: "Third-Party Integrations",
  description: "Strengthen operations by facilitating seamless integration with various legacy and modern applications, enhancing overall efficiency.",
  icon: Network
}];
export default function CoreErpModules() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="core-erp-modules" className="dark bg-background text-foreground relative py-24 md:py-32 overflow-hidden z-0">
      {}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-primary/40 via-background to-background opacity-80 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="text-center mb-16 md:mb-20">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground tracking-tight font-sans">
            Government-Grade Infrastructure
          </h2>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {modules.map((mod, i) => {
          const Icon = mod.icon;
          return <Card key={i} data-index={i} className="bg-card text-card-foreground border-border/50 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 ease-in-out rounded-xl overflow-hidden group">
                <CardHeader className="pb-4 pt-8 px-6">
                  <div className="w-14 h-14 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors duration-300">
                    <Icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl font-semibold leading-tight">
                    {mod.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-6 pb-8">
                  <p className="text-base text-muted-foreground leading-relaxed">
                    {mod.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}